/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_StockInputs */

const en_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock`)
};

const es_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo / Stock`)
};

const fr_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banque d'images`)
};

const de_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stock`)
};

const ja_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストック`)
};

const zh_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图库`)
};

const ar_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مخزون (Stock)`)
};

const id_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stok`)
};

const it_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivio / Stock`)
};

const ru_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сток`)
};

const pt_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banco de Imagens`)
};

const ko_val_stock = /** @type {(inputs: Val_StockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스톡`)
};

/**
* | output |
* | --- |
* | "Stock" |
*
* @param {Val_StockInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_stock = /** @type {((inputs?: Val_StockInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_StockInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_stock(inputs)
	if (locale === "es") return es_val_stock(inputs)
	if (locale === "fr") return fr_val_stock(inputs)
	if (locale === "de") return de_val_stock(inputs)
	if (locale === "ja") return ja_val_stock(inputs)
	if (locale === "zh") return zh_val_stock(inputs)
	if (locale === "ar") return ar_val_stock(inputs)
	if (locale === "id") return id_val_stock(inputs)
	if (locale === "it") return it_val_stock(inputs)
	if (locale === "ru") return ru_val_stock(inputs)
	if (locale === "pt") return pt_val_stock(inputs)
	return ko_val_stock(inputs)
});